export const MESSAGE_TYPE = {
  param: 'param',
  query: 'query',
};
